/**
 * Daily Lucky Picks — data + deterministic pick algorithm.
 *
 * Mirrors the constants/helpers inside pages/AstroToolsPage.jsx (LuckyTool).
 * They are duplicated rather than imported/exported because editing that page
 * triggers the editor's class-rewriter, which corrupts its inline gradient
 * backgrounds. Keep both in sync if the tool's data ever changes — the values
 * must produce identical picks for the same sign + day on both pages.
 */

export const RASHIS = [
  { en: 'Aries', sa: 'Mesha', lord: 'Mars', glyph: '♈' }, { en: 'Taurus', sa: 'Vrishabha', lord: 'Venus', glyph: '♉' },
  { en: 'Gemini', sa: 'Mithuna', lord: 'Mercury', glyph: '♊' }, { en: 'Cancer', sa: 'Karka', lord: 'Moon', glyph: '♋' },
  { en: 'Leo', sa: 'Simha', lord: 'Sun', glyph: '♌' }, { en: 'Virgo', sa: 'Kanya', lord: 'Mercury', glyph: '♍' },
  { en: 'Libra', sa: 'Tula', lord: 'Venus', glyph: '♎' }, { en: 'Scorpio', sa: 'Vrischika', lord: 'Mars', glyph: '♏' },
  { en: 'Sagittarius', sa: 'Dhanu', lord: 'Jupiter', glyph: '♐' }, { en: 'Capricorn', sa: 'Makara', lord: 'Saturn', glyph: '♑' },
  { en: 'Aquarius', sa: 'Kumbha', lord: 'Saturn', glyph: '♒' }, { en: 'Pisces', sa: 'Meena', lord: 'Jupiter', glyph: '♓' },
]

export const LUCKY_COLORS = ['Saffron', 'Deep Red', 'Golden Yellow', 'Emerald Green', 'Royal Blue', 'Ivory White', 'Amber', 'Maroon', 'Turquoise', 'Marigold', 'Sandalwood', 'Coral']
export const GEMSTONES = ['Ruby', 'Pearl', 'Red Coral', 'Emerald', 'Yellow Sapphire', 'Diamond', 'Blue Sapphire', 'Hessonite', "Cat's Eye"]
export const DIRECTIONS = ['East', 'North-East', 'North', 'North-West', 'West', 'South-West', 'South', 'South-East']
export const METALS = ['Gold', 'Silver', 'Copper', 'Bronze', 'Panchdhatu']
export const MANTRAS = ['Om Suryaya Namah', 'Om Chandraya Namah', 'Om Mangalaya Namah', 'Om Budhaya Namah', 'Om Gurave Namah', 'Om Shukraya Namah', 'Om Shanaye Namah']

export function hash(str) {
  let h = 2166136261
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return h >>> 0
}

export const pick = (arr, seed) => arr[((Math.trunc(seed) % arr.length) + arr.length) % arr.length]

/** Today's picks for a zodiac sign — same seed recipe as the Astro Tools page,
 * so both pages reveal identical fortunes for the same sign and day. */
export function getLuckyPicks(sign, dateStr) {
  const seed = hash(`${sign}|${dateStr}`)
  return {
    number: (seed % 9) + 1,
    colour: pick(LUCKY_COLORS, seed),
    gemstone: pick(GEMSTONES, seed >> 2),
    direction: pick(DIRECTIONS, seed >> 3),
    metal: pick(METALS, seed >> 4),
    mantra: pick(MANTRAS, seed >> 5),
    time: `${((seed >> 6) % 12) + 1}:00 – ${((seed >> 6) % 12) + 2}:00`,
  }
}
